type Point = {
  x: number;
  y: number;
};

/**
 * Returns a new point that is moved from `pt` towards `center` by the specified horizontal and vertical margins.
 * If `pt` is the same as `center`, returns `pt` unchanged.
 *
 * @param center - The center point to shrink towards.
 * @param marginHorizontal - The horizontal margin to shrink by.
 * @param marginVertical - The vertical margin to shrink by.
 * @param pt - The original point to shrink.
 * @returns The new shrunken point.
 */
export const shrinkPt = ({
  center,
  marginHorizontal = 5,
  marginVertical = 5,
  pt,
}: {
  center: Point;
  marginHorizontal?: number;
  marginVertical?: number;
  pt: Point;
}) => {
  const dx = center.x - pt.x;
  const dy = center.y - pt.y;
  const len = Math.sqrt(dx * dx + dy * dy);
  if (len === 0) return pt;
  return {
    x: pt.x + (dx / len) * marginHorizontal,
    y: pt.y + (dy / len) * marginVertical,
  };
};
